/* eslint-disable */

import app from '@/firebase';
import firebase from 'firebase/app';
import * as types from './mutations_type';
// import moment from 'moment';
import axios from 'axios';
import { SET_STORE_LIST } from './mutations_type';

const cors = '';//https://cors-anywhere.herokuapp.com/
const API_URL = 'https://haorich.tw/';
// const API_URL = 'http://localhost:3000/';
const PAY_API_URL = 'https://pay.haorich.tw/';
// const admin = require('firebase-admin');
const auth = app().auth();
const db = app().firestore();
const storageRef = app().storage().ref();


// 檢查版本
export async function checkVersion({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${API_URL}version/current?version=${data.version}&t=${new Date().getTime()}`,
    });
  } catch (e) {
    return e;
  }
}


// eslint-disable-next-line
function login({ commit }, userInfo) {
  console.log(`userInfo ${JSON.stringify(userInfo)}`);
  return new Promise((resolve, reject) => {
    auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        auth.signInWithEmailAndPassword(userInfo.account, userInfo.password).then((res) => {
          resolve(res);
        }).catch((err) => {
          console.log(`errorCode ${err} , errorMessage ${JSON.stringify(err.message)}`);
          reject(err);
        });
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(`errorCode ${errorCode} , errorMessage ${JSON.stringify(errorMessage)}`);
        reject(error);
      });
  });
}

async function fetchUserInfo({ commit }, id) {
  console.log(`fetchUserInfo == ${id}`);
  try {
    const snapshot = await db.collection('agents').doc(id).get();
    console.log('getUser', snapshot.data());
    commit(types.SET_USERINFO, snapshot.data());
    return snapshot.data();
  } catch (e) {
    console.log('getUser error', e);
    return e;
  }
  // return new Promise((resolve, reject) => {
  //   db.collection('agents').doc(id).get().then((snapshot) => {
  //     commit(types.SET_USERINFO, snapshot.data());
  //     resolve(snapshot.data());
  //   })
  //     .catch((err) => {
  //       console.debug('Error getting documents', err);
  //       reject(err);
  //     });
  // });
}
// eslint-disable-next-line
function logOut({ commit }) {
  console.debug(`logOut == ${auth}`);
  auth.signOut();
}

function fetchAgentList({ commit }) {
  return new Promise((resolve) => {
    db.collection('agents').orderBy('agentNumber', 'asc').onSnapshot((snapshot) => {
      const agentList = [];
      snapshot.forEach((doc) => {
        agentList.push(doc.data());
      });
      commit(types.SET_AGENT_LIST, agentList);
      resolve(agentList);
    });
  });
}

export function fetchStoreList({ commit }) {
  return new Promise((resolve) => {
    db.collection('ecuStoreList').orderBy('createDate', 'desc').onSnapshot((snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        list.push(doc.data());
      });
      commit(types.SET_STORE_LIST, list);
      resolve(list);
    });
  });
}

// eslint-disable-next-line
export function fetchMortgageInfo({ commit }, data) {
  return new Promise((resolve) => {
    db.collection('mortgageList').where('profileId', '==', `${data.profileId}`).get().then((snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        list.push(doc.data());
      });
      // console.log(`users == ${JSON.stringify(userList)}`);
      resolve(list);
    });
  });
}

// Login
export async function loginAgentService({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}agents/login`,
      data: {
        account: data.email,
      }
    });
  } catch (e) {
    return e;
  }
}

// 貸款
// eslint-disable-next-line
export async function getFinanceCreditList({ commit }, data) {
   try {
     return await axios({
       method: 'post',
       url: `${cors}${API_URL}finance/list`,
       headers:{
         token: data.token,
       },
       data: {
         agentId: data.agentId,
         searchValue: data.searchValue,
         pageIndex: data.pageIndex,
         limit: data.limit
       }
     });
   } catch (e) {
     return e;
   }
}

// 新貸款api
export async function getFinanceCreditNewList({ commit }, data) {
  console.log(`getFinanceCreditNewList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/newList`,
      headers:{
        token: data.token,
      },
      data: {
        agentId: data.agentId,
        searchKey: data.searchKey,
        searchValue: data.searchValue,
        startDate: data.startDate,
        endDate:  data.endDate,
        pageIndex: data.pageIndex,
        limit: data.limit,
        sortBy: data.sortBy ? data.sortBy : 'createDate',
        sortByValue: data.sortByValue ? data.sortByValue : 'DESC',
        searchQuery: data.searchQuery ? (data.searchQuery.length > 0 ? data.searchQuery : []) : [],
        showAll: data.showAll
      }
    });
  } catch (e) {
    return e;
  }
}


// 新CA api
export async function getCAFinanceCreditNewList({ commit }, data) {
  console.log(`getCAFinanceCreditNewList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/ca/newList`,
      headers:{
        token: data.token,
      },
      data: {
        agentId: data.agentId,
        searchKey: data.searchKey,
        searchValue: data.searchValue,
        startDate: data.startDate,
        endDate:  data.endDate,
        pageIndex: data.pageIndex,
        limit: data.limit,
        sortBy: data.sortBy ? data.sortBy : 'createDate',
        sortByValue: data.sortByValue ? data.sortByValue : 'DESC',
        searchQuery: data.searchQuery ? (data.searchQuery.length > 0 ? data.searchQuery : []) : []
      }
    });
  } catch (e) {
    return e;
  }
}


// 21世紀 列表 api
export async function getCCH21FinanceList({ commit }, data) {
  console.log(`getCCH21FinanceList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}cchFinance/cch21/list`,
      headers:{
      },
      data: {
        agentId: data.agentId,
        searchKey: data.searchKey,
        searchValue: data.searchValue,
        startDate: data.startDate,
        endDate:  data.endDate,
        pageIndex: data.pageIndex,
        limit: data.limit,
        sortBy: data.sortBy ? data.sortBy : 'createDate',
        sortByValue: data.sortByValue ? data.sortByValue : 'DESC',
        searchQuery: data.searchQuery ? (data.searchQuery.length > 0 ? data.searchQuery : []) : [],
        showAll: data.showAll
      }
    });
  } catch (e) {
    return e;
  }
}

// 嘉好列表 api
export async function getCCHFinanceList({ commit }, data) {
  console.log(`getCCHFinanceList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}cchFinance/list`,
      headers:{
      },
      data: {
        agentId: data.agentId,
        searchKey: data.searchKey,
        searchValue: data.searchValue,
        startDate: data.startDate,
        endDate:  data.endDate,
        pageIndex: data.pageIndex,
        limit: data.limit,
        sortBy: data.sortBy ? data.sortBy : 'createDate',
        sortByValue: data.sortByValue ? data.sortByValue : 'DESC',
        searchQuery: data.searchQuery ? (data.searchQuery.length > 0 ? data.searchQuery : []) : [],
        showAll: data.showAll
      }
    });
  } catch (e) {
    return e;
  }
}



// 案件經銷每日進件量
export async function getAgentCaseCountList({ commit }, data) {
  console.log(`getAgentCaseCountList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/agentCaseCount`,
      headers:{
      },
      data: {
        agentId: data.agentId,
        startDate: data.startDate,
        endDate:  data.endDate,
      }
    });
  } catch (e) {
    return e;
  }
}

export async function saveFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/save`,
      headers:{
        token: data.token,
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

// eslint-disable-next-line
export function fetchFinanceCreditList({ commit }, data) {
  return new Promise((resolve) => {
    const limit = 30;
    if (data.agentId && data.agentId !== '') {
      const ref =  db.collection('financeCreditList').where('parentAgent.agentId', '==', `${data.agentId}`)
        .orderBy('createDate', 'desc');
      if (data.isMobile && !data.isShowAllData){
        ref.limit(limit).get()
          .then((snapshot) => {
            const list = [];
            snapshot.forEach((doc) => {
              list.push(doc.data());
            });
            // console.log(`users == ${JSON.stringify(userList)}`);
            resolve(list);
          });
      } else {
        ref.get()
          .then((snapshot) => {
            const list = [];
            snapshot.forEach((doc) => {
              list.push(doc.data());
            });
            // console.log(`users == ${JSON.stringify(userList)}`);
            resolve(list);
          });
      }

    } else {
      const ref = db.collection('financeCreditList').orderBy('createDate', 'desc');
      if (data.isMobile && !data.isShowAllData){
        ref.limit(limit).get().then((snapshot) => {
          const list = [];
          snapshot.forEach((doc) => {
            list.push(doc.data());
          });
          // console.log(`users == ${JSON.stringify(userList)}`);
          resolve(list);
        });
      } else {
        ref.get().then((snapshot) => {
          const list = [];
          snapshot.forEach((doc) => {
            list.push(doc.data());
          });
          // console.log(`users == ${JSON.stringify(userList)}`);
          resolve(list);
        });
      }

    }
  });
}

//  貸款
// eslint-disable-next-line
export function saveFinanceCreditData({ commit }, data) {
  return db.collection('financeCreditList').doc(data.caseId).set(data);
}
// eslint-disable-next-line
export function removeFinanceCreditData({ commit }, data) {
  return db.collection('financeCreditList').doc(data.caseId).delete();
}

// 儲存官方對照資料
export async function saveFinanceOfficialData({ commit }, data) {
  return db.collection('financeOfficialList').doc(data.caseId).set(data);
}

export async function getFinanceOfficialData({ commit }, data) {
  return new Promise((resolve) => {
    db.collection('financeOfficialList').where('caseId', '==', `${data.caseId}`)
      .get().then((snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push(doc.data());
    });
    // console.log(`users == ${JSON.stringify(userList)}`);
    resolve(list[0]);
  });
});
}

//  貸款
// eslint-disable-next-line
export function fetchFinanceCreditInfo({ commit }, data) {
  return new Promise((resolve) => {
    db.collection('financeCreditList').where('caseId', '==', `${data.caseId}`).get().then((snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        list.push(doc.data());
      });
      // console.log(`users == ${JSON.stringify(userList)}`);
      resolve(list);
    });
  });
}
// eslint-disable-next-line
export function fetchFinanceCreditInfoBy({ commit }, data) {
  return new Promise((resolve) => {
    db.collection('financeCreditList').where(data.key, '==', `${data.value}`).get().then((snapshot) => {
      const list = [];
      snapshot.forEach((doc) => {
        list.push(doc.data());
      });
      resolve(list);
    });
  });
}


// 抵押文件
// eslint-disable-next-line
export function fetchMortgageList({ commit }, data) {
  return new Promise((resolve, reject) => {
    if (data.agentId && data.agentId !== '') {
      const list = [];
      db.collection('mortgageList')
        .where('parentAgent.agentId', '==', `${data.agentId}`)
        .orderBy('createDate', 'desc').get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            list.push(doc.data());
          });

          db.collection('mortgageList')
            .where('parentAgent.parentAgent.agentId', '==', `${data.agentId}`)
            .orderBy('createDate', 'desc').get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                list.push(doc.data());
              });
              // console.log(`users == ${JSON.stringify(userList)}`);
              resolve(list);
            });
        });
    } else {
      db.collection('mortgageList').orderBy('createDate', 'desc').get().then((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => {
          list.push(doc.data());
        });
        // console.log(`users == ${JSON.stringify(userList)}`);
        resolve(list);
      });
    }
  });
}
// eslint-disable-next-line
export function saveMortgageData({ commit }, data) {
  return db.collection('mortgageList').doc(data.profileId).set(data);
}
// eslint-disable-next-line
export function removeMortgageData({ commit }, data) {
  return db.collection('mortgageList').doc(data.profileId).delete();
}

// eslint-disable-next-line
export function fetchFinanceList({ commit }, data) {
  return new Promise((resolve) => {
    if (data.agentId && data.agentId !== '') {
      db.collection('financeList').where('parentAgent.agentId', '==', `${data.agentId}`)
        .orderBy('createDate', 'desc').get()
        .then((snapshot) => {
          const list = [];
          snapshot.forEach((doc) => {
            list.push(doc.data());
          });
          // console.log(`users == ${JSON.stringify(userList)}`);
          resolve(list);
        });
    } else {
      db.collection('financeList').orderBy('createDate', 'desc').get().then((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => {
          list.push(doc.data());
        });
        // console.log(`users == ${JSON.stringify(userList)}`);
        resolve(list);
      });
    }
  });
}
// eslint-disable-next-line
export function saveFinanceData({ commit }, data) {
  return db.collection('financeList').doc(data.memberId).set(data);
}

export function updateFinanceData({commit}, data) {
  // console.log(`saveUserData == ${JSON.stringify(data)}`);
  return db.collection('financeCreditList').doc(data.caseId).update(data.info);
}

// eslint-disable-next-line
export function removeFinanceData({ commit }, data) {
  return db.collection('financeList').doc(data.memberId).delete();
}

//檢查 原融案號是否重複
export function fetchCreditProductInfo({commit} , query) {
  console.log(`fetchCreditProductInfo == ${JSON.stringify(query)}`);
  return new Promise((resolve, reject) => {
    db.collection('financeCreditList').where("caseId", "==", `${query.caseId}`).get().then((snapshot) => {
      let list = [];
      snapshot.forEach(doc => {
        list.push(doc.data());
      });
      console.log(`fetchCreditProductInfo == ${list.length}`);
      resolve(list);
    });
  });
}

// 儲存 原融
export function saveCreditProduct({commit}, data) {
  // console.log(`saveUserData == ${JSON.stringify(data)}`);
  return db.collection('financeCreditList').doc(data.caseId).set(data);
}

// 變更原融 案件狀態 API
export async function syncCreditProductStatus({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/updateCaseStatus`,
      headers:{
        token: data.token,
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

export async function updateRealPrice({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/updateRealPrice`,
      data: data
    });
  } catch (e) {
    return e;
  }
}


export function fetchAgentInfo({commit}, data) {
  return new Promise((resolve, reject) => {
    db.collection('agents').where('agentId', '==', data.agentId).get().then((snapshot) => {
      let agentList = [];
      snapshot.forEach(doc => {
        agentList.push(doc.data());
      });
      resolve(agentList);
    });
  });
}

export function saveFinanceCaseType({commit} , data) {
  return db.collection('financeCreditList').doc(data.caseId).update({
    'header.caseType5': data.caseType5 ? data.caseType5: '',
    'header.caseType4': data.caseType4 ? data.caseType4: '',
    'header.caseType': data.caseType ? data.caseType: '',
  });
}

export function saveFinanceSignImage({commit} , data) {
  return db.collection('financeCreditList').doc(data.caseId).update({
    signImage0: data.signImage0 ? data.signImage0: '',
    signImage1: data.signImage1 ? data.signImage1: '',
    signImage2: data.signImage2 ? data.signImage2: '',
    signImage3: data.signImage3 ? data.signImage3: '',
  });
}

export function uploadImageData({commit}, data) {
  console.log(`uploadImageData URL : ${data.name}`);
  console.log(`uploadImageData  : ${JSON.stringify(data)}`);
  return new Promise((resolve, reject) => {
    // const blob = new Blob([data.image], { type: data.name.indexOf('png') ? "image/png" : "image/jpeg" });
    const uploadTask = storageRef.child(data.name)
      // .put(blob, 'data_url');
      .putString(data.image, 'data_url');
    uploadTask.on('state_changed', // or 'state_changed'
      function (snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
        switch (snapshot.state) {
          case 'paused': // or 'paused'
            console.log('Upload is paused');
            break;
          case 'running': // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;

          case 'storage/canceled':
            // User canceled the upload
            break;
          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
        reject(error);
      }, function () {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          console.log('File available at', downloadURL);
          resolve(downloadURL);
        });
      });
  });
}

export function uploadBlobData({commit}, Blob) {
  return new Promise((resolve, reject) => {
    const name = `${new Date().getTime()}.png`;
    storageRef.child('deliveryNoteList').child(name).put(Blob).then((snapshot) => {
      console.log('Uploaded a blob or file!');
      snapshot.ref.getDownloadURL().then(function (downloadURL) {
        console.log('File available at', downloadURL);
        resolve(downloadURL);
      });
    });
  });
}


// 查詢ECU店家
export function fetchECUStoreList({commit} ,data) {
  return new Promise((resolve, reject) => {
    if (!data) {
      data = { orderBy: 'desc', status: -1 };
    }
    if (data.status === -1){
      db.collection('ecuStoreList').orderBy("createDate", data.orderBy).onSnapshot((snapshot) => {
        const list = [];
        snapshot.forEach(doc => {
          list.push(doc.data());
        });
        // console.log(`productList == ${JSON.stringify(productList)}`);
        commit(types.SET_ECU_STORE_LIST, list);
        resolve(list);
      });
    } else {
      db.collection('ecuStoreList').where('parentAgent.agentId', '==', data.agentId).orderBy("createDate", 'desc').get().then((snapshot) => {
        const list = [];
        snapshot.forEach(doc => {
          list.push(doc.data());
        });
        // console.log(`productList == ${JSON.stringify(productList)}`);
        commit(types.SET_ECU_STORE_LIST, list);
        resolve(list);
      });
    }

  });
}

export function getImageUrl({commit}, path) {
  return storageRef.child(path).getDownloadURL();
}

export function configAgentInfo({commit}, data) {
  commit(types.SET_AGENT_INFO, data);
}

export function saveAgent({commit}, data) {
  console.log(`saveAgent == ${JSON.stringify(data)}`);
  return db.collection('agents').doc(data.agentId).set(data);
}

export async function disableUser({commit} , data) {
  try {
    return await axios({
      method: 'post',
      url: `https://us-central1-chiahao-92b7e.cloudfunctions.net/disableUser`,
      data: data,
      json: true,
    });
  } catch (e) {
    return e;
  }
}

export async function createNewAgent({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `https://us-central1-chiahao-92b7e.cloudfunctions.net/createUser`,
      data: data,
      json: true,
    });
  } catch (e) {
    return e;
  }
}

// 附加檔案
export async function saveAttachmentFile({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/saveAttachmentFile`,
      data
    });
  } catch (e) {
    return e;
  }
}


// 進件至裕富
export async function saveToFinanceOfficial({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveOfficial`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存問題
export async function saveCaseQuestion({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveCaseQuestion`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 案件申覆紀錄
export async function fetchExamList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/examList`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 案件申覆案件已處理
export async function saveExamResult({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/exam/finish`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 圓融案件詢問
export async function fetchQuestionList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/questions`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 更新問題狀態
export async function saveQuestionStatus({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updateQuestion`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 更新問題狀態
export async function saveAllQuestionStatus({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updateQuestion`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 新增公告
export async function createNotice({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}notice/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 更新公告
export async function saveNotice({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}notice/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 刪除公告
export async function deleteNotice({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}notice/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 公告列表
export async function getNoticeList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}notice/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 公告列表
export async function getNoticeInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}notice/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 更新案編
export async function updateCaseId({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updateCaseId`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 取當日進件量
export async function getFinanceCountInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/caseCountInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存合約
export async function saveContractInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}contract/create`,
      data
    });
  } catch (e) {
    return e;
  }
}


// 取合約
export async function getContractInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}contract/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存合約
export async function updateContractInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}contract/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

//申辦性別分析
export async function getGenderInfo({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}report/gender`,
      data
    });
  } catch (e) {
    return e;
  }
}
//每日核准率
export async function getApprovedInfo({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}report/approved`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 年度走勢
export async function getYearApprovedInfo({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}report/year/approved`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 當月業績/佣金
export async function getBonusInfo({commit}, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}report/bonus`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 銀行帳目資料列表
export async function saveSettingData({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updateSettingPrice`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveCaseResult({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveResult`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getCaseResultList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/resultList`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存對保資料
export async function createInsureInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/createInsureInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 儲存對保資料 - 修改
export async function saveInsureInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveInsureInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 儲存對保資料 - 刪除
export async function deleteInsureInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/deleteInsureInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 儲存對保資料 - 查詢
export async function getInsureInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/getInsureInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 儲存對保資料 - 列表
export async function getInsureInfoList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/getInsureInfoList`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getAdminInsureInfoList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/insureInfoList`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getExportInsureInfoList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/export/insureInfoList`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 對保資料核銷
export async function writeOffInsureInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveInsureInfo/status`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存經辦人
export async function saveContactInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveContactInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 儲存CA的經辦人
export async function saveCaContactInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/update/agent`,
      data
    });
  } catch (e) {
    return e;
  }
}

//儲存匯入陣列
export async function saveMultiResult({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveMultiResult`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 撥款通知 api
export async function getPriceNoticeList({ commit }, data) {
  // console.log(`getPriceNoticeList === ${JSON.stringify(data)}`);
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/priceInfoList`,
      headers:{
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

// 待撥款清單 api
export async function getRequestPaymentList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/requestPaymentList`,
      headers:{
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

// 已撥款清單 api
export async function getPaymentFinishList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/getPaymentFinishList`,
      headers:{
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

// 問題件清單 api
export async function getPaymentErrorList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${cors}${API_URL}finance/getPaymentErrorList`,
      headers:{
      },
      data: data
    });
  } catch (e) {
    return e;
  }
}

//刪除 撥款紀錄
export async function deleteRealPriceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/deletePriceInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}


//匯入 撥款紀錄
export async function saveMultiPriceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/saveMultiPriceInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}

//刪除案件
export async function deleteCaseInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 取得商品貸的初始資訊
export async function caseRuleInfo({ commit }) {
  try {
    return await axios({
      method: 'get',
      url: `${API_URL}caFinance/rule`
    });
  } catch (e) {
    return e;
  }
}

// 新增
// 傳applicationModel
export async function caCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/create`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 查單一案件
// {
//   caseId:""
// }
export async function caInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/info`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 更新CA案件
export async function caUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

//刪除CA案件
export async function deleteCaInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}cafinance/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

// CA List
// {
//   "startDate"
//   "endDate"
//   "pageIndex"
//   "limit"
// }
export async function caList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 刪除案件
// {
//   caseId:""
// }
export async function caDelete({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}
// CA進件
// data: ApplicationModel
export async function caSend({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/send`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getCaCountInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}caFinance/caseCountInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 優撥新增api
export async function savePriceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/savePriceInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 優撥更新api
export async function updatePriceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updatePriceInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 優撥更新狀態api
export async function updatePriceInfoStatus({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/updatePriceInfoStatus`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 裕富線上請款api
export async function requestPayment({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/requestPayment`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 裕富線上撥款狀態
export async function queryAppropriation({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/queryAppropriation`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 裕富線上案件狀態查詢
// {
//   salesId: '',
//   displayId:'',
//  memberId:''
// }
export async function queryCaseStatus({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/queryCaseStatus`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 裕富線上審件補件
export async function requestSupplement({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/requestSupplement`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 裕富線上案件申覆爭取
export async function requestForExam({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/requestForExam`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 裕富線上重新照會
export async function reCallout({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/reCallout`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 查詢銀行帳戶資料
export async function recordInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/recordInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 查詢銀行帳戶列表
export async function recordList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/record/list`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 新增銀行帳戶款項進出紀錄
export async function createRecord({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/createRecord`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 更新銀行帳戶資料
export async function updateBank({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/updateBank`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 查詢帳戶資料
export async function bankInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/bankInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 銀行帳戶列表
export async function bankList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢帳戶資料
export async function searchBankInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/search/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 建立常用帳戶
export async function saveBankInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/createBankAccount`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 刪除常用帳戶
export async function deleteBankInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/deleteBankAccount`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 新增銀行帳戶
export async function createBank({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/createBank`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 銀行帳目資料刪除
export async function deleteBank({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/deleteBank`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 匯款紀錄刪除
export async function deleteRecord({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/deleteRecord`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 匯款紀錄修改
export async function updateRecord({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}bank/updateRecord`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 刪除機車商品資料
export async function motoDelete({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 查詢機車商品列表
export async function motoList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/list`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 更新機車商品資料
export async function motoUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/update`,
      data
    });
  } catch (e) {
    return e;
  }
}
// 新增機車商品
export async function motoCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 新增整流器種類
export async function createProductType({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/type/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 取得整流器種類
export async function getProductType({ commit }) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/type/list`,
    });
  } catch (e) {
    return e;
  }
}

// 取得ECU群組列表
export async function ecuList({ commit }) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/group/list`
    });
  } catch (e) {
    return e;
  }
}

// 新增ECU群組
export async function ecuCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/group/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 編輯ECU群組
export async function ecuUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/group/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 刪除ECU群組
export async function ecuDelete({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/group/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 新增商品庫存
export async function stockCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/stock/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 編輯商品庫存
export async function stockUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/stock/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 商品庫存列表
export async function stockTypeList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/stock/type/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 商品庫存列表
export async function stockList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/stock/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢商品庫存明細
export async function stockInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/stock/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢商品庫存明細
export async function getProductId({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}moto/product/id`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢出貨店家列表
export async function storeList({ commit }) {
  try {
    return await axios({
      method: 'get',
      url: `${API_URL}delivery/store/list`
    });
  } catch (e) {
    return e;
  }
}

// 新增出貨單
export async function orderCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}delivery/order/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 編輯出貨單
export async function orderUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}delivery/order/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢出貨列表
export async function orderList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}delivery/order/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 查詢出貨單明細
export async function orderInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}delivery/order/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function originUpdate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}origin/finance/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function originList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}origin/finance/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function originInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}origin/finance/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function originCreate({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}origin/finance/create`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function saveAutoCheckBonus({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/autoCheckBonus`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getCaseStatusLog({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/getCaseStatusLog`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getNotifyAppropriationList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/getNotifyAppropriationList`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function changeNotifyTip({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/changeNotifyTip`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function searchFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 變更專案代碼
export async function changePromotionInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/changePromotionInfo`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function searchFastFinanceList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}fastFinance/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveFastFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}fastFinance/update`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function savePreparePaymentInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}payment/prepare`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function searchPaymentInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}payment/result`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getPaymentList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}payment/list`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function saveMarketPaymentInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}marketPayment/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getMarketPaymentInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}marketPayment/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

// 國泰刷卡
export async function getCathayCreditInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${PAY_API_URL}payment/cathay/credit/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getFileList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}file/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveFileInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}file/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function updateFileInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}file/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function deleteFileInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}file/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveFileSetting({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}file/fileSetting/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveCCHCategorySetting({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}cchFinance/setting/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function loadCCHCategorySetting({ commit }, data) {
  try {
    const time = new Date().getTime();
    return await axios({
      method: 'get',
      url: `${API_URL}cchFinance/setting/info?t=${time}`,
    });
  } catch (e) {
    return e;
  }
}


export async function saveCCHProjects({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}cchFinance/project/save`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function loadCCHProjects({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}cchFinance/project/list`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function loadAppropriationInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}appropriation/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function createAppropriationInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}appropriation/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function updateAppropriationInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}appropriation/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function deleteAppropriationInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}appropriation/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}


export async function getAppropriationList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}appropriation/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getFinanceSimpleInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/info/simple`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getFinanceSimpleList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/info/simple/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getAssignorInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/getAssignor/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getDocList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveDocInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function updateDocInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function deleteDocInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getDocInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function loadFastFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}fastFinance/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveGoodDealInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}fastFinance/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveGoodDealFiles({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}fastFinance/save/files`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveExportLog({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}export/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveAgentToken({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}users/setToken`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function verifyToken({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${API_URL}users/verifyToken`,
      headers:{
        token: data.token,
      },
    });
  } catch (e) {
    return e;
  }
}

export async function getCompanyReport({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}company/report`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveCarFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}carFinance/create`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function updateCarFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}carFinance/update`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function deleteCarFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}carFinance/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getCarFinanceInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}carFinance/info`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getCarFinanceList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}carFinance/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getAssignorList({ commit }, data) {
  try {
    return await axios({
      method: 'get',
      url: `${API_URL}users/assignor/list?agentId=${data.agentId}&t=${new Date().getTime()}`,
    });
  } catch (e) {
    return e;
  }
}

export async function saveAssignorInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/assignor/save`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function deleteAssignorInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}finance/assignor/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function saveTradeInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}trade/save`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function getTradeList({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}trade/list`,
      data
    });
  } catch (e) {
    return e;
  }
}

export async function removeTradeInfo({ commit }, data) {
  try {
    return await axios({
      method: 'post',
      url: `${API_URL}trade/delete`,
      data
    });
  } catch (e) {
    return e;
  }
}

export {
  login,
  fetchUserInfo,
  logOut,
  fetchAgentList,
};



// WEBPACK FOOTER //
// ./src/store/actions.js